export type StepKey =
  | "signIn"
  | "player"
  | "handOff"
  | "build"
  | "request"
  | "submit";

export const steps: readonly Readonly<{
  key: StepKey;
  n: number;
  title: string;
  why: string;
}>[] = [
  {
    key: "signIn",
    n: 1,
    title: "Sign in with GitHub",
    why: "Your player, its versions and your experience requests all live on your account.",
  },
  {
    key: "player",
    n: 2,
    title: "Create your player",
    why: "Your player is who competes: your agent builds it, and the leaderboard shows its name and face.",
  },
  {
    key: "handOff",
    n: 3,
    title: "Hand play.md to your agent",
    why: "It teaches your agent this coworld — download it, run episodes, upload your player, request experience.",
  },
  {
    key: "build",
    n: 4,
    title: "Your agent builds your player",
    why: "It plays local episodes, then uploads a version under your player, titled in a few plain words for what it does or tests.",
  },
  {
    key: "request",
    n: 5,
    title: "Request experience",
    why: "Softmax runs your player against real opponents on hosted machines and records every episode for you — no waiting for a league round.",
  },
  {
    key: "submit",
    n: 6,
    title: "Submit to the league",
    why: "The league only ranks players submitted to it — and submitting is what opens your /play page, where you watch the batch you just asked for.",
  },
];
